import firebaseConfig from "../layouts/dev.firebase.config.js";
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  apiDomain: "http://localhost:8000/api/",
  firebaseCDN: firebaseConfig,
  NODE_ENV: "Development",
};

// http://orange.stringconsultants.com/
